import { Button, Result } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const PaymentSuccessful = () => {
  const navigate = useNavigate();
  const [counter, setCounter] = useState(10);
  const counterInMills = 10 * 1000;
  const search = useLocation().search;
  const projectId = new URLSearchParams(search).get("project_id");
  const navigateToPlayground = () => {
    if (projectId) {
      navigate(`/verticals/playground/${projectId}`);
    } else {
      navigate("/");
    }
  };
  useEffect(() => {
    const timer = setInterval(() => {
      setCounter((prevCounter) => prevCounter - 1);
    }, 1000);

    // Automatically navigate after 10 seconds
    const timeout = setTimeout(() => {
      navigateToPlayground();
    }, counterInMills);

    // Cleanup the intervals and timeout when component unmounts
    return () => {
      clearInterval(timer);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <Result
      status="success"
      title="Payment Successful"
      subTitle="Payment update might takes 1-5 minutes, please wait."
      extra={[
        <Button type="primary" key="console" onClick={navigateToPlayground}>
          Go Back (in {counter})
        </Button>,
      ]}
    />
  );
};

export { PaymentSuccessful };
